import { ILocationService } from 'angular';
import { USER_ROLE_PERMISSIONS_FOR_STATES } from '../../../ng2/shared/constants/user-role-permissions-for-states.constant';

angular.module('nv.routes.other').config(function($stateProvider) {
  $stateProvider.state('root', {
    url: '/',
    controller: [
      '$timeout',
      '$state',
      '$location',
      function($timeout, $state, $location: ILocationService) {
        $timeout(function() {
          // We use $location.url to make compatible with ng2 `login` route (CM).
          $location.url('/login');
        });
      },
    ],
    data: {
      roles: USER_ROLE_PERMISSIONS_FOR_STATES.root,
    },
  });
});
